/**
 * Created by mac on 2/23/20
 */

const SideBarIcon = function (options) {
    this.available = false;
    this.extraBarIcon = undefined;
    this.animation = undefined;
    this.animationName = undefined;
    this.skin = undefined;
    this.locked = false;
    this.disabled = false;
    this.attention = false;
    this.title = undefined;
    this.titleIcon = undefined;
    this.leftTime = undefined;
    this.place = undefined;
    this.priority = SideBar.PRIORITY_NORMAL;

    Object.assign(this, options);

    this.clearListeners();
};

SideBarIcon.prototype.clearListeners = function () {
    this.onShowIconListener = function () {};

    this.onUnlockListener = function () {};

    this.onEnableListener = function () {};
    this.onDisableListener = function () {};

    this.onAttentionOnListener = function () {};
    this.onAttentionOffListener = function () {};
    this.onUpdateAttentionCounter = function () {};

    this.onFingerOnListener = function () {};
    this.onFingerOffListener = function () {};

    this.onChangeTitleListener = function () {};
    this.onChangePlaceListener = function () {};
    this.onChangeProgressListener = function () {};
    this.onReceiveIncomeListener = function () {};

    this.onStartTimerListener = function () {};
    this.onRemoveTimerListener = function () {};

    this.onShowForce = function () {};
};

SideBarIcon.prototype.getTargetTypes = function () {
    return this.targets;
};

SideBarIcon.prototype.getSideBarIcon = function () {
    const json = (typeof this.animation === "function") ? this.animation(this) : this.animation;
    if (!json) {
        return;
    }
    
    const icon = {
        json,
        animation: "animation"
    };

    if (this.animationName && cleverapps.Spine.hasAnimation(this.animationName, icon.json)) {
        icon.animation = this.animationName;
    }

    if (this.transition && cleverapps.Spine.hasAnimation(this.transition, icon.json)) {
        icon.transition = this.transition;
    }

    if (this.skin && cleverapps.Spine.hasSkin(this.skin, icon.json)) {
        icon.skin = this.skin;
    }

    return icon;
};

SideBarIcon.prototype.getExtraBarIcon = function () {
    return typeof this.extraBarIcon === "function" ? this.extraBarIcon(this) : this.extraBarIcon;
};

SideBarIcon.prototype.setAnimation = function (animationName, transition) {
    if (this.animationName !== animationName) {
        this.transition = this.animationName && transition;
        this.animationName = animationName;
        this.onShowIconListener();
        this.transition = undefined;
    }
};

SideBarIcon.prototype.setSkin = function (skin) {
    if (this.skin !== skin) {
        this.skin = skin;

        this.onShowIconListener();
    }
};

SideBarIcon.prototype.setDisabled = function (disabled) {
    disabled = !!disabled;

    if (this.disabled !== disabled) {
        this.disabled = disabled;

        if (this.disabled) {
            this.onDisableListener();
        } else {
            this.onEnableListener();
        }
    }
};

SideBarIcon.prototype.setLocked = function (locked) {
    locked = !!locked;
    if (this.locked !== locked) {
        this.locked = locked;

        if (!this.locked) {
            this.onUnlockListener();
        }
    }
};

SideBarIcon.prototype.setAttention = function (attention) {
    attention = !!attention;
    if (this.attention !== attention) {
        this.attention = attention;

        if (attention) {
            this.onAttentionOnListener();
        } else {
            this.onAttentionOffListener();
        }
    }
};

SideBarIcon.prototype.getAttention = function () {
    return this.attention;
};

SideBarIcon.prototype.setFinger = function (finger) {
    finger = !!finger;
    if (this.finger !== finger) {
        this.finger = finger;

        if (finger) {
            this.onFingerOnListener();
        } else {
            this.onFingerOffListener();
        }
    }
};

SideBarIcon.prototype.setTitle = function (title) {
    if (this.title !== title) {
        this.title = title;

        this.onChangeTitleListener();
    }
};

SideBarIcon.prototype.setPlace = function (place) {
    if (this.place !== place) {
        this.place = place;

        this.onChangePlaceListener();
    }
};

SideBarIcon.prototype.setProgress = function (progress) {
    if ((this.progress && this.progress.amount) !== (progress && progress.amount)
        || (this.progress && this.progress.target) !== (progress && progress.target)) {
        this.progress = progress;

        this.onChangeProgressListener();
    }
};

SideBarIcon.prototype.receiveIncome = function (amount, f) {
    if (!this.onReceiveIncomeListener(amount, f)) {
        f();
    }
};

SideBarIcon.prototype.setLeftTime = function (leftTime) {
    if (this.leftTime !== leftTime) {
        this.leftTime = leftTime;
    }

    if (this.leftTime > 0) {
        this.onStartTimerListener();
    } else {
        this.onRemoveTimerListener();
    }
};

SideBarIcon.prototype.getLeftTime = function () {
    return this.leftTime;
};

SideBarIcon.prototype.resetState = function () {

};

SideBarIcon.prototype.getLockedTipData = function () {
    return undefined;
};

SideBarIcon.prototype.onPressed = function () {

};

SideBarIcon.prototype.getForce = function () {
    return undefined;
};

SideBarIcon.prototype.getIncomeIcon = function () {
    return undefined;
};

SideBarIcon.prototype.getTitle = function () {
    if (this.locked) {
        if (this.locked.lockedEvent) {
            return Messages.get("Soon");
        }

        return Messages.get("IconLocked.TextDefault", {
            levelNo: cleverapps.humanReadableNumber({ floatLevel: this.locked.level })
        });
    }

    return this.title;
};

SideBarIcon.prototype.getToolTip = function () {
    if (this.locked) {
        return {
            text: Messages.get("IconLocked.TipDefault", {
                level: this.getLockedTipData()
            })
        };
    }
};

// An icon is drawn by the sidebar icon prefab unless it names a view class of its own - the quests
// group is one, it spans several slots and draws a scroll instead of a single icon.
SideBarIcon.prototype.getView = function () {
    return undefined;
};

SideBarIcon.prototype.countOfSlots = function () {
    return 1;
};

SideBarIcon.prototype.onShow = function () {

};

SideBarIcon.prototype.onHide = function () {

};
